export class BPM {}
export class BSC {}
export class SYNERGY {}
